import { render } from "./deleteArticle.vue?vue&type=template&id=6b69a9b7"
import script from "./deleteArticle.vue?vue&type=script&lang=js"
export * from "./deleteArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__